<template><div><h1>vux-loader 使用</h1>
<h2>安装</h2>
<pre class="hljs"><code>npm install vux-loader --save-dev
</code></pre>
<h2>使用</h2>
<p>为了降低使用成本及不侵入原来配置，只需要调用<code>merge</code>方法对原来<code>webpack</code>配置进行操作：</p>
<pre class="hljs"><code><span class="hljs-keyword">const</span> webpackConfig = {} <span class="hljs-comment">// 原来的 webpack.base.js 配置</span>

<span class="hljs-keyword">const</span> vuxLoader = <span class="hljs-built_in">require</span>(<span class="hljs-string">'vux-loader'</span>)

<span class="hljs-built_in">module</span>.exports = vuxLoader.merge(webpackConfig, {
  <span class="hljs-attr">options</span>: {},
  <span class="hljs-attr">plugins</span>: [{
    <span class="hljs-attr">name</span>: <span class="hljs-string">'vux-ui'</span>
  }]
})
</code></pre>
<div class="warning">
<p>更新配置后需要重新运行 <code>npm run dev</code> 命令。</p>
</div>
<h2>Options</h2>
<ul>
<li><code>env</code> 非必选，定义当前环境变量，只在 vux-loader 里使用，用来判断哪些插件需要被执行(如果plugin有定义envs的话)，目的是实现一份配置多个环境使用。</li>
</ul>
<h2>Plugins</h2>
<p>插件为一个数组列表，根据需要可以添加你需要的插件，插件名为必须，有些组件不需要额外配置选项。</p>
<p>公用参数为:</p>
<ul>
<li><code>name</code> <code>必须</code>，插件名字</li>
<li><code>envs</code> <code>非必须</code>，数组，当前插件在哪些环境变量里执行，不定义则默认执行</li>
</ul>
<p>下面的插件配置代码将省略 <code>plugins:[]</code>的书写。</p>
<div class="tip">
<p>当使用默认配置时，可以使用简写</p>
<pre class="hljs"><code>plugins: [<span class="hljs-string">'vux-ui'</span>]
</code></pre>
<p>等同于</p>
<pre class="hljs"><code>plugins: [{
  <span class="hljs-attr">name</span>: <span class="hljs-string">'vux-ui'</span>
}]
</code></pre>
</div>
</div></template><script>
export default {
  head: {"title":"vux-loader 使用 | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// install-192.vue?dd407d20